import Link from '@components/ui-old/link';
import Image from "next/image";
import { useWindowSize } from '@utils/use-window-size';
import cn from 'classnames';
import { LinkProps } from 'next/link';
import { useSsrCompatible } from '@utils/use-ssr-compatible';
import { getPublicBaseUrl } from '@utils/getPublicBaseUrl';
interface BannerProps {
  banner: any;
  variant?: 'rounded' | 'default';
  effectActive?: boolean;
  className?: string;
  classNameInner?: string;
  href?: LinkProps['href'];
  disableBorderRadius?: boolean;
}
function getImage(deviceWidth: number, imgObj: any) {
  return {
    url: `${getPublicBaseUrl()}${imgObj}`,
    width: 1800,
    height: 800,
    deviceWidth: deviceWidth
  };
}
export default function BannerCard({
  banner,
  className,
  variant = 'rounded',
  effectActive = false,
  classNameInner,
  href,
  disableBorderRadius = false
}: BannerProps) {
  const {
    width
  } = useSsrCompatible(useWindowSize(), {
    width: 0,
    height: 0
  });
  const {
    title,
    image
  } = banner;
  const selectedImage = getImage(width, image);
  return <div className={cn('mx-auto', className)} data-sentry-component="BannerCard" data-sentry-source-file="banner-card.tsx">
      {href ? <Link href={href} passHref legacyBehavior>
          <a target="_blank" rel="noopener noreferrer" className={cn('h-full group flex justify-center relative overflow-hidden', classNameInner)}>
            <Image src={selectedImage.url} width={selectedImage.width} height={selectedImage.height} alt={title} quality={100} className={cn('bg-gray-300 object-cover w-full', {
          'rounded-md': variant === 'rounded' && !disableBorderRadius
        })} priority={true} style={{
          maxWidth: "100%",
          height: "auto"
        }} />
            {effectActive && <div className='absolute top-0 ltr:-left-[100%] rtl:-right-[100%] h-full w-1/2 z-5 block transform ltr:-skew-x-12 rtl:skew-x-12 bg-gradient-to-r from-transparent to-white opacity-40 ltr:group-hover:animate-shine rtl:group-hover:animate-shineRTL' />}
          </a>
        </Link> : <div className={cn('h-full flex justify-center relative overflow-hidden', classNameInner)}>
          <Image src={selectedImage.url} width={selectedImage.width} height={selectedImage.height} alt={title} quality={100} className={cn('bg-gray-300 object-cover w-full', {
        'rounded-md': variant === 'rounded' && !disableBorderRadius
      })} priority={true} style={{
        maxWidth: "100%",
        height: "auto"
      }} />
          {effectActive && <div className='absolute top-0 ltr:-left-[100%] rtl:-right-[100%] h-full w-1/2 z-5 block transform ltr:-skew-x-12 rtl:skew-x-12 bg-gradient-to-r from-transparent to-white opacity-40 ltr:group-hover:animate-shine rtl:group-hover:animate-shineRTL' />}
        </div>}
    </div>;
}